import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SerbiaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15848'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15848)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 9.33329H20V4.66663H0V9.33329Z'
					fill='#17508F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 4.66667H20V0H0V4.66667Z'
					fill='#E1444D'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M4.28516 6.99996C4.28516 6.58667 4.4908 5.70892 4.63181 5.15563C4.70568 4.86579 4.96818 4.66663 5.26729 4.66663H7.11376C7.41229 4.66663 7.67446 4.86511 7.74858 5.15429C7.88957 5.70443 8.09468 6.57737 8.09468 6.99996C8.09468 7.50413 7.76065 8.80053 7.65211 9.20846C7.63006 9.29136 7.59224 9.36806 7.5362 9.43301C7.32857 9.67368 6.75924 10.2666 6.18992 10.2666C5.62013 10.2666 5.05035 9.67272 4.84313 9.43243C4.78744 9.36785 4.74976 9.29165 4.72768 9.20928C4.61909 8.80424 4.28516 7.51662 4.28516 6.99996Z'
					fill='white'
				/>
				<mask
					id='mask1_2332_15848'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='4'
					y='4'
					width='5'
					height='7'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M4.28516 6.99996C4.28516 6.58667 4.4908 5.70892 4.63181 5.15563C4.70568 4.86579 4.96818 4.66663 5.26729 4.66663H7.11376C7.41229 4.66663 7.67446 4.86511 7.74858 5.15429C7.88957 5.70443 8.09468 6.57737 8.09468 6.99996C8.09468 7.50413 7.76065 8.80053 7.65211 9.20846C7.63006 9.29136 7.59224 9.36806 7.5362 9.43301C7.32857 9.67368 6.75924 10.2666 6.18992 10.2666C5.62013 10.2666 5.05035 9.67272 4.84313 9.43243C4.78744 9.36785 4.74976 9.29165 4.72768 9.20928C4.61909 8.80424 4.28516 7.51662 4.28516 6.99996Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask1_2332_15848)'>
					<path
						d='M8.09431 5.13329L4.28478 9.79996'
						stroke='#E1444D'
						strokeWidth='1.33333'
						strokeLinecap='square'
					/>
					<path
						d='M4.2846 5.13329L8.09412 9.79996'
						stroke='#E1444D'
						strokeWidth='1.33333'
						strokeLinecap='square'
					/>
				</g>
			</g>
		</svg>
	);
};

export default SerbiaFlagIcon;
